import type { TranslationInterface } from '.';

export const SwedishLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Skriv ett meddelande...',
  your_issue_has_been_resolved: 'Ditt problem har lösts!',
  new_conversation: 'Ny konversation',
  welcome_screen_title: 'Välkommen till vår supportchatt',
  welcome_screen_description:
    'Vi är här för att hjälpa! Starta en konversation så återkommer vi till dig så snart som möjligt.',
  your_name_placeholder: 'Ditt namn',
  your_email_placeholder: 'Din e-postadress',
  start_chat_button: 'Prata med support',
  start_chat_button_loading: 'Ansluter...',
  i_need_more_help: 'Jag behöver mer hjälp',
  this_was_helpful: 'Detta var användbart',
  optional: 'Frivilligt',
  no_conversations_yet: 'Inga konversationer ännu',
  back_to_conversations: 'Tillbaka till konversationer',
  closed_conversations: 'Stängda konversationer',
  csat_title: 'Hur var din konversation?',
  csat_submitted_title: 'Du betygsatte konversationen som',
  csat_feedback_placeholder: 'Berätta mer... (valfritt)',
  follow_up_placeholder: 'Följ upp…',
  companion_layout_label: 'Layout',
  companion_layout_floating: 'Flytande',
  companion_layout_sidebar: 'Sidopanel',
  companion_layout_fullscreen: 'Helskärm',
  companion_close: 'Stäng',
  companion_history: 'Konversationshistorik',
  companion_expand_chat: 'Expandera chatten',
  companion_sidebar_dock_label: 'Dockning',
  companion_sidebar_side_label: 'Sida',
  companion_sidebar_left: 'Vänster',
  companion_sidebar_right: 'Höger',
  companion_resize_chat: 'Ändra chattens storlek',
  scroll_to_bottom: 'Rulla längst ned',
  thinking: 'Tänker…',
  running: 'Körs…',
  steps: 'steg',
  step_arguments: 'Argument',
  step_result: 'Resultat',
  attach_files:
    'Bifoga bilder, videor, PDF-filer eller kalkylblad (maximal storlek 25 MB)',
  mark_page_active:
    'Klicka på något på sidan för att markera det — Esc för att avbryta',
  mark_page: 'Markera något på sidan för att fråga om det',
  stop_response: 'Stoppa svaret',
  copy_reply: 'Kopiera svar',
  mentions_empty: 'Inga träffar',
  copied: 'Kopierat',
  send_message: 'Skicka meddelande',
  upload_failed: 'Uppladdningen misslyckades: {error}',
  remove_attachment: 'Ta bort bilaga',
  json_no_items: 'Inga objekt',
  json_no_data: 'Inga data',
  json_no_chart_data: 'Inga data för diagrammet',
  json_unsupported: 'Stöds inte: {type}',
  json_see_less: 'Visa mindre',
  json_phone_agent: 'Telefonagent',
  json_phone_agent_test: 'Testa via webben',
  page_context_remove: 'Ta bort sidkontext',
  json_see_more: 'Visa ytterligare {count}',
  queued_label: '{count} I kö',
  remove_queued_message: 'Ta bort meddelandet från kön',
  send_queued_now: 'Skicka köade meddelanden nu',
  turn_failed_message: 'Något gick fel och svaret kom inte fram.',
  turn_failed_retry: 'Försök igen',
  page_mark_hint: 'Klicka på något för att markera det',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Ruta',
  page_mark_shape_circle: 'Cirkel',
  page_mark_shape_arrow: 'Pil',
  page_mark_shape_bracket: 'Hakparentes',
  page_mark_shape_underline: 'Understrykning',
  page_mark_shape_highlight: 'Markering',
  page_mark_shape_strike_through: 'Genomstrykning',
  page_mark_shape_crossed_off: 'Kryssa över',
  page_mark_shape_aria: 'Markeringsform: {shape}',
  page_mark_note_placeholder: 'Lägg till en anteckning… (Enter för att bifoga)',
  page_mark_attach: 'Bifoga markering',
  page_mark_remove: 'Ta bort {label}',
  page_mark_region: 'Markerat område',
  page_mark_default_message: 'Vad är det här?',
  file_rejected: 'Filtypen stöds inte eller filen är för stor.',
  dictate: 'Diktera',
  stop_dictation: 'Sluta diktera',
  dictation_mic_blocked: 'Tillåt mikrofonåtkomst för att diktera',
  dictation_unavailable: 'Diktering är inte tillgänglig just nu',
  questions_back: 'Tillbaka',
  questions_next: 'Nästa',
  questions_send: 'Skicka',
  questions_type_answer: 'Jag skriver själv',
  questions_answer_placeholder: 'Skriv ditt svar…',
  close_conversation_title: 'Avsluta konversation',
  close_conversation_description:
    'Är du säker på att du vill avsluta den här konversationen?',
  close_conversation_cancel: 'Nej',
  close_conversation_confirm: 'Ja',
  dialog_close: 'Stäng',
  zoom_in: 'Zooma in',
  zoom_out: 'Zooma ut',
  reset_zoom: 'Återställ zoom',
  support_chat_aria_label: 'Supportchatt',
};
